/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationEnrollmentChildrenFilterViewModel } from "../types/CourseRegistrationEnrollmentChildrenFilterViewModel.ts";
import { eCompanyFilterTypeSchema } from "./eCompanyFilterTypeSchema.ts";
import { eDocumentSelectFilterSchema } from "./eDocumentSelectFilterSchema.ts";

export const courseRegistrationEnrollmentChildrenFilterViewModelSchema =
  z.object({
    classStudentId: z.optional(z.number().int()),
    poloId: z.number().int().nullish(),
    filter: z.optional(
      z
        .lazy(() => eCompanyFilterTypeSchema)
        .describe("1 = Main | 2 = Company | 3 = All | "),
    ),
    companyId: z.number().int().nullish(),
    status: z.optional(z.number().int()),
    studentName: z.string().nullish(),
    email: z.string().nullish(),
    cpf: z.string().nullish(),
    documents: z.optional(
      z
        .lazy(() => eDocumentSelectFilterSchema)
        .describe("0 = All | 1 = WithDocuments | 2 = WithoutDocuments | "),
    ),
    documentStartDate: z.string().datetime().nullish(),
    documentEndDate: z.string().datetime().nullish(),
  }) as unknown as ToZod<CourseRegistrationEnrollmentChildrenFilterViewModel>;
